import React, { useCallback } from 'react';
import { LFC } from '../../Legacy';
import { CommandDispatcher } from '../../concepts/commands/CommandDispatcher';
import { useSubmitter } from '../../platform/Hook';
import { ResultInfoForSubmitter } from '../../ui/ResultInfo';
import { useResolve } from '../Container';
import { Copy, Em, Spacer } from '../dashboard/elements/LayoutElements';
import { Popup, PopupProps } from '../popups/Popup';
import { Button, Prompt } from './../../ui';
import { boardDelete } from './BoardCommands';

export const BoardDeletePopup: LFC<PopupProps> = ({ action, dismiss, args }) => {
    const { board } = args;

    const dispatch = useResolve(CommandDispatcher);

    const [onSubmit, working, result] = useSubmitter(async () => action(await dispatch(boardDelete, [board.id, 'YES'])), [board]);

    const onPromptAction = useCallback((confirm: boolean) => {
        if (!confirm) dismiss();
        else onSubmit();
    }, [onSubmit]);

    return <Prompt onAction={working ? null : onPromptAction}>
        <Popup w={32}>
            <Popup.Close onAction={() => onPromptAction(false)} />
            <Popup.Title>Delete Board</Popup.Title>
            <Popup.Content>
                <Copy>
                    Are you sure you want to <Em>permanently delete</Em> this board?  This cannot be undone.
                </Copy>
                <Spacer f={2} />
                <ResultInfoForSubmitter result={result} />
            </Popup.Content>
            <Popup.Actions>
                <Button disabled={working} variant="negative" onAction={onSubmit}>
                    {working ? 'Deleting...' : 'Delete'}
                </Button>
                <Button disabled={working} onAction={dismiss}>
                    Cancel
                </Button>
            </Popup.Actions>
        </Popup>
    </Prompt>;
};
